import useAuth from '@State/Auth/useAuth';
import useImpersonate from '@State/Impersonate/useImpersonate';
import usePermissions from '@State/Permissions/usePermissions';
import { useKeycloak } from '@State/Keycloak/KeycloakProvider';
import React from 'react';

export const useLoadingState = () => {
  const { token, parsedToken } = useAuth();
  const { hasFetched, getImpersonate } = useImpersonate();
  const { permissions, getPermissions } = usePermissions();
  const { initialized, initError } = useKeycloak();

  // Check if we need to fetch permissions
  React.useEffect(() => {
    if (!permissions && token) {
      getPermissions();
    }
  }, [token, permissions, getPermissions]);

  // Check if we need to fetch impersonation data
  React.useEffect(() => {
    if (parsedToken?.useradmin && token && !hasFetched) {
      getImpersonate();
    }
  }, [token, parsedToken, hasFetched, getImpersonate]);

  // Return true if any of these conditions are true:
  // 1. Keycloak is not initialized yet, and has not given up either
  //    (initError): a failed init must release the loader so that App can
  //    show ServiceUnavailable or a public page instead of spinning forever
  // 2. We have a token but no permissions yet
  // 3. We have a token but no parsed token yet
  const isLoading =
    (!initialized && !initError) || (token && !permissions) || (token && !parsedToken);

  return isLoading;
};
